var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPosition2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_807_38147)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 15.0625H8.99999V14.0625C8.99999 12.6925 10.073 11.7145 11.112 10.7695C12.083 9.8845 13 9.0495 13 8.0625C13 7.5105 12.551 7.0625 12 7.0625C11.449 7.0625 11 7.5105 11 8.0625H8.99999C8.99999 6.4085 10.346 5.0625 12 5.0625C13.654 5.0625 15 6.4085 15 8.0625C15 9.9335 13.591 11.2165 12.458 12.2485C12.159 12.5205 11.855 12.7985 11.603 13.0625H15V15.0625ZM24 14.3485C24 14.3485 22.756 13.6605 20.879 13.3405C21.89 13.2095 23.055 12.7735 23.552 11.5305C24.514 9.1225 23.629 5.9115 23.629 5.9115C23.629 5.9115 22.323 6.4015 20.988 7.6615C21.677 6.5985 22.362 5.0415 21.691 3.6925C20.54 1.3765 17.5 0.0625 17.5 0.0625C17.5 0.0625 16.115 3.9195 18.142 7.9255C18.957 12.8215 17.499 15.8705 16.095 17.5865C14.832 19.1305 13.274 20.0095 12 20.3215C10.726 20.0085 9.16899 19.1295 7.90499 17.5865C6.50099 15.8695 5.04299 12.8215 5.85799 7.9255C7.88499 3.9195 6.49999 0.0625 6.49999 0.0625C6.49999 0.0625 3.45999 1.3765 2.30899 3.6925C1.63799 5.0425 2.32399 6.5985 3.01199 7.6615C1.67699 6.4015 0.370986 5.9115 0.370986 5.9115C0.370986 5.9115 -0.514014 9.1225 0.447986 11.5305C0.943986 12.7735 2.10899 13.2095 3.12099 13.3405C1.24399 13.6605 -1.42909e-05 14.3485 -1.42909e-05 14.3485C-1.42909e-05 14.3485 1.80199 17.1095 4.19199 17.8755C4.28699 17.9065 4.37999 17.9355 4.47099 17.9635C2.89399 18.9085 1.99999 19.9375 1.99999 19.9375C1.99999 19.9375 3.98399 21.9995 6.92799 22.0155C6.30999 23.0285 6.04499 23.7785 6.04499 23.7785C6.04499 23.7785 9.47099 24.5525 12 23.5255C14.529 24.5525 17.955 23.7785 17.955 23.7785C17.955 23.7785 17.69 23.0285 17.072 22.0155C20.015 21.9995 22 19.9375 22 19.9375C22 19.9375 21.106 18.9085 19.529 17.9635C19.62 17.9355 19.712 17.9065 19.808 17.8755C22.198 17.1095 24 14.3485 24 14.3485Z",
    fill: "url(#paint0_linear_807_38147)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_807_38147",
    x1: 25.4989,
    y1: -0.0624997,
    x2: 4.49882,
    y2: 23.9366,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCDFE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#ADB1CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DCDFE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#ADB1CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCDFE8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_807_38147"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.0625)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPosition2);
export default __webpack_public_path__ + "static/media/Position-2.b8f3af6759b9b20e365527374672abea.svg";
export { ForwardRef as ReactComponent };